import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      value: _ctx.computedCodigoSelecionado,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigoSelecionado) = $event)),
      loading: _ctx.state.buscandoDados,
      options: _ctx.selecionarBase.listaOpcoes,
      placeholder: _ctx.state.buscandoDados ? 'Carregando...' : _ctx.props.placeholder,
      disabled: _ctx.props.disabled || _ctx.state.buscandoDados,
      allowClear: _ctx.props.limparSelecao,
      "show-search": true,
      "filter-option": false,
      "option-filter-prop": "label",
      class: "ss-tamanho-completo",
      "field-names": { label: 'label', value: 'value' },
      onChange: _ctx.change,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pesquisarRelatorio(''))),
      onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarRelatorio($event))),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false))
    }, _createSlots({ _: 2 }, [
      (_ctx.state.buscandoDados)
        ? {
            name: "notFoundContent",
            fn: _withCtx(() => [
              _createTextVNode(" Buscando Relatórios "),
              _createVNode(_component_a_spin, { size: "small" })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["value", "loading", "options", "placeholder", "disabled", "allowClear", "onChange"])
  ]))
}